<template>
  <div
    style="width: 100%; height: 100%"
    fluid
    v-if="showLayout"
    @click.stop.prevent
    :class="[
      $store.state.states.isClonePattern || $store.state.states.isOrderPattern ? 'clone-pattern-bv' : '',
      'bv-example-row bv-example-row-flex-cols'
    ]"
    :style="containerStyle"
  >
    <template v-if="!hasTabsTiledPlugin">
      <div
        @drop="handleColsDragover($event, 0)"
        @dragover.prevent
        @click="titleClick(directions[0])"
        class="other_content"
        v-show="options.titleOptions[0].isShow"
        :style="{ height: options.titleOptions[0].height + 'px' }"
        :class="options.titleOptions[0].type"
      >
        <vueDragResizable
          v-for="(elementOption, index) in options.titleOptions[0].elementOptions"
          v-show="elementOption.isShow"
          :class="[
            `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_0-elementInLayoutId_${elementOption.elementInLayoutId}`,
            elementOption.isActive ? 'active' : ''
          ]"
          :key="'layoutComponent' + index"
          :data-innerElement="'element is:' + elementOption.innerElement"
          :parentW="getParentW"
          :parentH="options.titleOptions[0].height"
          :w="Number(elementOption.options.width)"
          :h="Number(elementOption.options.height)"
          :x="Number(elementOption.options.left)"
          :y="Number(elementOption.options.top)"
          :isLayoutTitle="true"
          :parent="true"
          :zoom="zoom"
          :direction="Number(directions[0])"
          :elementInLayoutId="elementOption.elementInLayoutId"
          :elementName="elementOption.innerElement"
          :active="elementOption.isActive"
          :options="elementOption.options"
          :rectId="myid.rect_id"
          :shape="elementOption.innerElement"
          v-on:dragging="draggingEv"
          v-on:resizing="resizingEv"
          v-on:resizeStop="resizestopEv"
          v-on:dragStop="dragstopEv"
          v-on:activated="activeEv"
          v-on:deactivated="deactive"
          v-on:delElement="delElementEv"
          @refLineParams="getRefLineParams($event, Number(directions[0]))"
          @click.stop.prevent
          @mouseup.stop.prevent
          @mousedown.stop.prevent
          :myId="{ ...myid, elementInLayoutId: elementOption.elementInLayoutId, directionIndex: Number(directions[0]) }"
        >
          <component
            class="rect"
            v-if="elementOption.isShow"
            :options="elementOption.options"
            :myid="{
              ...myid,
              elementInLayoutId: elementOption.elementInLayoutId,
              directionIndex: Number(directions[0])
            }"
            :is="elementOption.innerElement"
          >
          </component>
        </vueDragResizable>
        <!--辅助线-->
        <template v-for="(lineOption, index6) in lineList">
          <span
            class="ref-line v-line"
            v-for="item in lineOption.vLine"
            :key="'vLine' + item.id + index6"
            v-show="item.display && Number(directions[0]) == index6"
            :style="{
              left: item.position,
              top: item.origin,
              height: item.lineLength
            }"
          />
          <span
            class="ref-line h-line"
            v-for="item in lineOption.hLine"
            :key="'hLine' + item.id + index6"
            v-show="item.display && Number(directions[0]) == index6"
            :style="{
              top: item.position,
              left: item.origin,
              width: item.lineLength
            }"
          />
        </template>
        <!--辅助线END-->
        <!--拖拽线-->
        <div
          class="custom-handle"
          draggable="true"
          @mouseup.stop
          @mousedown.stop
          @dragstart.stop="changeHeightMouseDownEv"
          @dragend.stop="changeHeightMouseUpEv"
          :style="getHandleStyle(options.titleOptions[0])"
        ></div>
      </div>
      <div class="content_otherLR" :class="isBigScreenPreview() ? 'zIndex0' : ''" :style="getContentHeight">
        <div v-show="isDrawerModeL && options.titleOptions[2].isShow">
          <el-drawer
            v-if="showDrawer"
            @drop.native="handleColsDragover($event, 2)"
            @dragover.prevent.native
            @click.native="titleClick(directions[2])"
            :size="options.titleOptions[2].width"
            direction="ltr"
            :visible.sync="drawerL"
            :with-header="false"
            :append-to-body="inBodyL"
            :modal-append-to-body="inBodyL"
          >
            <div
              class="other_content"
              v-show="isDrawerModeL === false && options.titleOptions[2].isShow"
              :style="{ width: options.titleOptions[2].width + 'px' }"
              :class="options.titleOptions[2].type"
            >
              <vueDragResizable
                v-for="(elementOption, index) in options.titleOptions[2].elementOptions"
                :key="'layoutComponent' + index"
                :class="[
                  elementOption.isActive ? 'active' : '',
                  `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_2-elementInLayoutId_${elementOption.elementInLayoutId}`
                ]"
                :data-innerElement="'element is:' + elementOption.innerElement"
                :parentW="options.titleOptions[2].width"
                :parentH="getParentH"
                :w="Number(elementOption.options.width)"
                :h="Number(elementOption.options.height)"
                :x="Number(elementOption.options.left)"
                :y="Number(elementOption.options.top)"
                :isLayoutTitle="true"
                :parent="true"
                :zoom="zoom"
                :direction="Number(directions[2])"
                :elementInLayoutId="elementOption.elementInLayoutId"
                :elementName="elementOption.innerElement"
                :active="elementOption.isActive"
                :options="elementOption.options"
                :rectId="myid.rect_id"
                :shape="elementOption.innerElement"
                v-on:dragging="draggingEv"
                v-on:resizing="resizingEv"
                v-on:resizeStop="resizestopEv"
                v-on:dragStop="dragstopEv"
                v-on:activated="activeEv"
                v-on:deactivated="deactive"
                v-on:delElement="delElementEv"
                @refLineParams="getRefLineParams($event, Number(directions[2]))"
                @click.stop.prevent
                @mouseup.stop.prevent
                @mousedown.stop.prevent
                :myId="{
                  ...myid,
                  elementInLayoutId: elementOption.elementInLayoutId,
                  directionIndex: Number(directions[2])
                }"
              >
                <component
                  v-if="elementOption.isShow"
                  class="rect"
                  :options="elementOption.options"
                  :myid="{
                    ...myid,
                    elementInLayoutId: elementOption.elementInLayoutId,
                    directionIndex: Number(directions[2])
                  }"
                  :is="elementOption.innerElement"
                >
                </component>
              </vueDragResizable>
              <template v-for="(lineOption, index6) in lineList">
                <span
                  class="ref-line v-line"
                  v-for="item in lineOption.vLine"
                  :key="'vLine' + item.id + index6"
                  v-show="item.display && Number(directions[2]) == index6"
                  :style="{
                    left: item.position,
                    top: item.origin,
                    height: item.lineLength
                  }"
                />
                <span
                  class="ref-line h-line"
                  v-for="item in lineOption.hLine"
                  :key="'hLine' + item.id + index6"
                  v-show="item.display && Number(directions[2]) == index6"
                  :style="{
                    top: item.position,
                    left: item.origin,
                    width: item.lineLength
                  }"
                />
              </template>
              <div
                class="custom-handle"
                draggable="true"
                @mouseup.stop
                @mousedown.stop
                @dragstart.stop="changeHeightMouseDownEv"
                @dragend.stop="changeHeightMouseUpEv"
                :style="getHandleStyle(options.titleOptions[2])"
              ></div>
            </div>
          </el-drawer>
        </div>
        <div
          @drop="handleColsDragover($event, 2)"
          @dragover.prevent
          @click="titleClick(directions[2])"
          class="other_content"
          v-show="isDrawerModeL === false && options.titleOptions[2].isShow"
          :style="{ width: options.titleOptions[2].width + 'px' }"
          :class="options.titleOptions[2].type"
        >
          <vueDragResizable
            v-for="(elementOption, index) in options.titleOptions[2].elementOptions"
            :key="'layoutComponent' + index"
            :class="[
              elementOption.isActive ? 'active' : '',
              `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_2-elementInLayoutId_${elementOption.elementInLayoutId}`
            ]"
            :data-innerElement="'element is:' + elementOption.innerElement"
            :parentW="options.titleOptions[2].width"
            :parentH="getParentH"
            :w="Number(elementOption.options.width)"
            :h="Number(elementOption.options.height)"
            :x="Number(elementOption.options.left)"
            :y="Number(elementOption.options.top)"
            :isLayoutTitle="true"
            :parent="true"
            :zoom="zoom"
            :direction="Number(directions[2])"
            :elementInLayoutId="elementOption.elementInLayoutId"
            :elementName="elementOption.innerElement"
            :active="elementOption.isActive"
            :options="elementOption.options"
            :rectId="myid.rect_id"
            :shape="elementOption.innerElement"
            v-on:dragging="draggingEv"
            v-on:resizing="resizingEv"
            v-on:resizeStop="resizestopEv"
            v-on:dragStop="dragstopEv"
            v-on:activated="activeEv"
            v-on:deactivated="deactive"
            v-on:delElement="delElementEv"
            @refLineParams="getRefLineParams($event, Number(directions[2]))"
            @click.stop.prevent
            @mouseup.stop.prevent
            @mousedown.stop.prevent
            :myId="{
              ...myid,
              elementInLayoutId: elementOption.elementInLayoutId,
              directionIndex: Number(directions[2])
            }"
          >
            <component
              v-if="elementOption.isShow"
              class="rect"
              :options="elementOption.options"
              :myid="{
                ...myid,
                elementInLayoutId: elementOption.elementInLayoutId,
                directionIndex: Number(directions[2])
              }"
              :is="elementOption.innerElement"
            >
            </component>
          </vueDragResizable>
          <template v-for="(lineOption, index6) in lineList">
            <span
              class="ref-line v-line"
              v-for="item in lineOption.vLine"
              :key="'vLine' + item.id + index6"
              v-show="item.display && Number(directions[2]) == index6"
              :style="{
                left: item.position,
                top: item.origin,
                height: item.lineLength
              }"
            />
            <span
              class="ref-line h-line"
              v-for="item in lineOption.hLine"
              :key="'hLine' + item.id + index6"
              v-show="item.display && Number(directions[2]) == index6"
              :style="{
                top: item.position,
                left: item.origin,
                width: item.lineLength
              }"
            />
          </template>
          <div
            class="custom-handle"
            draggable="true"
            @mouseup.stop
            @mousedown.stop
            @dragstart.stop="changeHeightMouseDownEv"
            @dragend.stop="changeHeightMouseUpEv"
            :style="getHandleStyle(options.titleOptions[2])"
          ></div>
        </div>
        <div class="content_center scroller" :style="getScrollStyle" v-if="!options.turnOnScroll || emptyData">
          <cx-big-screen-row
            v-if="!emptyData"
            :zoom="zoom"
            :rowsOptions="activeOptions"
            :options="options"
            :myid="myid"
            :style="getWidth"
          />
          <!-- 空数据 -->
          <div class="null-data" v-else>
            <img src="../../../assets/images/img-null-data-light.png" alt="" />
            <p>暂无数据</p>
          </div>
        </div>
        <div class="content_center1" v-else>
          <div ref="realBox" class="realBox" :style="getScrollStyle1" @mouseenter="enter" @mouseleave="leave">
            <div ref="slotList" class="content_center_div">
              <cx-big-screen-row
                :zoom="zoom"
                :rowsOptions="activeOptions"
                :options="options"
                :myid="myid"
                :style="getWidth"
              />
            </div>
            <div v-html="copyHtml" class="content_center_div1"></div>
          </div>
        </div>
        <div v-show="options.titleOptions[3].isShow && isDrawerModeR">
          <el-drawer
            v-if="showDrawer"
            @drop.native="handleColsDragover($event, 3)"
            @dragover.native.prevent
            @click.native="titleClick(directions[3])"
            :size="options.titleOptions[3].width"
            :visible.sync="drawerR"
            :append-to-body="inBodyR"
            :with-header="false"
            :modal-append-to-body="inBodyR"
          >
            <div
              class="other_content"
              :style="{ width: options.titleOptions[3].width + 'px' }"
              :class="options.titleOptions[3].type"
            >
              <vueDragResizable
                v-for="(elementOption, index) in options.titleOptions[3].elementOptions"
                :key="'layoutComponent' + index"
                :class="[
                  elementOption.isActive ? 'active' : '',
                  `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_3-elementInLayoutId_${elementOption.elementInLayoutId}`
                ]"
                :data-innerElement="'element is:' + elementOption.innerElement"
                :parentW="options.titleOptions[3].width"
                :parentH="getParentH"
                :w="Number(elementOption.options.width)"
                :h="Number(elementOption.options.height)"
                :x="Number(elementOption.options.left)"
                :y="Number(elementOption.options.top)"
                :isLayoutTitle="true"
                :parent="true"
                :zoom="zoom"
                :direction="Number(directions[3])"
                :elementInLayoutId="elementOption.elementInLayoutId"
                :elementName="elementOption.innerElement"
                :active="elementOption.isActive"
                :options="elementOption.options"
                :rectId="myid.rect_id"
                :shape="elementOption.innerElement"
                v-on:dragging="draggingEv"
                v-on:resizing="resizingEv"
                v-on:resizeStop="resizestopEv"
                v-on:dragStop="dragstopEv"
                v-on:activated="activeEv"
                v-on:deactivated="deactive"
                v-on:delElement="delElementEv"
                @refLineParams="getRefLineParams($event, Number(directions[3]))"
                @click.stop.prevent
                @mouseup.stop.prevent
                @mousedown.stop.prevent
                :myId="{
                  ...myid,
                  elementInLayoutId: elementOption.elementInLayoutId,
                  directionIndex: Number(directions[3])
                }"
              >
                <component
                  v-if="elementOption.isShow"
                  class="rect"
                  :options="elementOption.options"
                  :myid="{
                    ...myid,
                    elementInLayoutId: elementOption.elementInLayoutId,
                    directionIndex: Number(directions[3])
                  }"
                  :is="elementOption.innerElement"
                >
                </component>
              </vueDragResizable>
              <!--辅助线-->
              <template v-for="(lineOption, index6) in lineList">
                <span
                  class="ref-line v-line"
                  v-for="item in lineOption.vLine"
                  :key="'vLine' + item.id + index6"
                  v-show="item.display && Number(directions[3]) == index6"
                  :style="{
                    left: item.position,
                    top: item.origin,
                    height: item.lineLength
                  }"
                />
                <span
                  class="ref-line h-line"
                  v-for="item in lineOption.hLine"
                  :key="'hLine' + item.id + index6"
                  v-show="item.display && Number(directions[3]) == index6"
                  :style="{
                    top: item.position,
                    left: item.origin,
                    width: item.lineLength
                  }"
                />
              </template>
              <!--辅助线END-->
              <!--拖拽线-->
              <div
                class="custom-handle"
                draggable="true"
                @mouseup.stop
                @mousedown.stop
                @dragstart.stop="changeHeightMouseDownEv"
                @dragend.stop="changeHeightMouseUpEv"
                :style="getHandleStyle(options.titleOptions[3])"
              ></div>
            </div>
          </el-drawer>
        </div>
        <div
          @drop="handleColsDragover($event, 3)"
          @dragover.prevent
          @click="titleClick(directions[3])"
          class="other_content"
          v-show="options.titleOptions[3].isShow && isDrawerModeR === false"
          :style="{ width: options.titleOptions[3].width + 'px' }"
          :class="options.titleOptions[3].type"
        >
          <vueDragResizable
            v-for="(elementOption, index) in options.titleOptions[3].elementOptions"
            :key="'layoutComponent' + index"
            :class="[
              elementOption.isActive ? 'active' : '',
              `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_3-elementInLayoutId_${elementOption.elementInLayoutId}`
            ]"
            :data-innerElement="'element is:' + elementOption.innerElement"
            :parentW="options.titleOptions[3].width"
            :parentH="getParentH"
            :w="Number(elementOption.options.width)"
            :h="Number(elementOption.options.height)"
            :x="Number(elementOption.options.left)"
            :y="Number(elementOption.options.top)"
            :isLayoutTitle="true"
            :parent="true"
            :zoom="zoom"
            :direction="Number(directions[3])"
            :elementInLayoutId="elementOption.elementInLayoutId"
            :elementName="elementOption.innerElement"
            :active="elementOption.isActive"
            :options="elementOption.options"
            :rectId="myid.rect_id"
            :shape="elementOption.innerElement"
            v-on:dragging="draggingEv"
            v-on:resizing="resizingEv"
            v-on:resizeStop="resizestopEv"
            v-on:dragStop="dragstopEv"
            v-on:activated="activeEv"
            v-on:deactivated="deactive"
            v-on:delElement="delElementEv"
            @refLineParams="getRefLineParams($event, Number(directions[3]))"
            @click.stop.prevent
            @mouseup.stop.prevent
            @mousedown.stop.prevent
            :myId="{
              ...myid,
              elementInLayoutId: elementOption.elementInLayoutId,
              directionIndex: Number(directions[3])
            }"
          >
            <component
              v-if="elementOption.isShow"
              class="rect"
              :options="elementOption.options"
              :myid="{
                ...myid,
                elementInLayoutId: elementOption.elementInLayoutId,
                directionIndex: Number(directions[3])
              }"
              :is="elementOption.innerElement"
            >
            </component>
          </vueDragResizable>
          <!--辅助线-->
          <template v-for="(lineOption, index6) in lineList">
            <span
              class="ref-line v-line"
              v-for="item in lineOption.vLine"
              :key="'vLine' + item.id + index6"
              v-show="item.display && Number(directions[3]) == index6"
              :style="{
                left: item.position,
                top: item.origin,
                height: item.lineLength
              }"
            />
            <span
              class="ref-line h-line"
              v-for="item in lineOption.hLine"
              :key="'hLine' + item.id + index6"
              v-show="item.display && Number(directions[3]) == index6"
              :style="{
                top: item.position,
                left: item.origin,
                width: item.lineLength
              }"
            />
          </template>
          <!--辅助线END-->
          <!--拖拽线-->
          <div
            class="custom-handle"
            draggable="true"
            @mouseup.stop
            @mousedown.stop
            @dragstart.stop="changeHeightMouseDownEv"
            @dragend.stop="changeHeightMouseUpEv"
            :style="getHandleStyle(options.titleOptions[3])"
          ></div>
        </div>
      </div>
      <div
        @drop="handleColsDragover($event, 1)"
        @dragover.prevent
        @click="titleClick(directions[1])"
        class="other_content"
        v-show="options.titleOptions[1].isShow"
        :style="{ height: options.titleOptions[1].height + 'px' }"
        :class="options.titleOptions[1].type"
      >
        <vueDragResizable
          v-for="(elementOption, index) in options.titleOptions[1].elementOptions"
          v-show="elementOption.isShow"
          :class="[
            elementOption.isActive ? 'active' : '',
            `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_1-elementInLayoutId_${elementOption.elementInLayoutId}`
          ]"
          :key="'layoutComponent' + index"
          :data-innerElement="'element is:' + elementOption.innerElement"
          :parentW="getParentW"
          :parentH="options.titleOptions[1].height"
          :w="elementOption.options ? Number(elementOption.options.width) : 0"
          :h="elementOption.options ? Number(elementOption.options.height) : 0"
          :x="elementOption.options ? Number(elementOption.options.left) : 0"
          :y="elementOption.options ? Number(elementOption.options.top) : 0"
          :isLayoutTitle="true"
          :parent="true"
          :zoom="zoom"
          :direction="Number(directions[1])"
          :elementInLayoutId="elementOption.elementInLayoutId"
          :elementName="elementOption.innerElement"
          :active="elementOption.isActive"
          :options="elementOption.options"
          :rectId="myid.rect_id"
          :shape="elementOption.innerElement"
          v-on:dragging="draggingEv"
          v-on:resizing="resizingEv"
          v-on:resizeStop="resizestopEv"
          v-on:dragStop="dragstopEv"
          v-on:activated="activeEv"
          v-on:deactivated="deactive"
          v-on:delElement="delElementEv"
          @refLineParams="getRefLineParams($event, Number(directions[1]))"
          @click.stop.prevent
          @mouseup.stop.prevent
          @mousedown.stop.prevent
          :myId="{ ...myid, elementInLayoutId: elementOption.elementInLayoutId, directionIndex: Number(directions[1]) }"
        >
          <component
            v-if="elementOption.isShow"
            class="rect"
            :options="elementOption.options"
            :myid="{
              ...myid,
              elementInLayoutId: elementOption.elementInLayoutId,
              directionIndex: Number(directions[1])
            }"
            :is="elementOption.innerElement"
          >
          </component>
        </vueDragResizable>
        <!--辅助线-->
        <template v-for="(lineOption, index6) in lineList">
          <span
            class="ref-line v-line"
            v-for="item in lineOption.vLine"
            :key="'vLine' + item.id + index6"
            v-show="item.display && Number(directions[1]) == index6"
            :style="{
              left: item.position,
              top: item.origin,
              height: item.lineLength
            }"
          />
          <span
            class="ref-line h-line"
            v-for="item in lineOption.hLine"
            :key="'hLine' + item.id + index6"
            v-show="item.display && Number(directions[1]) == index6"
            :style="{
              top: item.position,
              left: item.origin,
              width: item.lineLength
            }"
          />
        </template>
        <!--辅助线END-->
        <!--拖拽线-->
        <div
          class="custom-handle"
          draggable="true"
          @mouseup.stop
          @mousedown.stop
          @dragstart.stop="changeHeightMouseDownEv"
          @dragend.stop="changeHeightMouseUpEv"
          :style="getHandleStyle(options.titleOptions[1])"
        ></div>
      </div>
    </template>
    <template v-else>
      <div class="content_center scroller" :style="getScrollStyle" v-for="(row, index) in options.rows" :key="index">
        <cx-big-screen-row :zoom="zoom" :rowsOptions="row" :options="options" :myid="myid" :style="getWidth" />
        <!-- 空数据 -->
        <!-- <div class="null-data" v-else>
          <img src="../../../assets/images/img-null-data-light.png" alt="" />
          <p>暂无数据</p>
        </div> -->
      </div>
    </template>
  </div>
</template>

<script>
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentBigScreenUpdateData.js"
import {
  findTabs,
  _throttle,
  _debounce,
  deepChangeUid,
  findHistoryLayoutType,
  simpleDeepClone
} from "utils"
import plugins from "./plugin"
import eventMixin from "utils/event/eventMixin.js"
import componentsMixin from "./componentsMixin.js"
import communicationMixin from "./communicationMixin.js"
import { CATEGORY_MODE } from "@/consts/index.js"

export default {
  mixins: [componentsMixin, eventMixin, plugins, communicationMixin],
  name: "layoutComponentBigScreen",
  components: {},
  data() {
    return {
      isMounted: false,
      reloadTimer: null,
      showDrawer: false,
      showLayout: true,
      getParentW: null,
      getParentH: null,
      textOptions: {
        type: Array,
        default: []
      },
      activeTabId: "",
      lineList: [
        {
          vLine: [],
          hLine: []
        },
        {
          vLine: [],
          hLine: []
        },
        {
          vLine: [],
          hLine: []
        },
        {
          vLine: [],
          hLine: []
        }
      ],
      appId: null,
      pageId: null,
      restDataUrl: null,
      typeVal: null,
      websiteId: null,
      wfwfid: null,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      restUrl: null,
      initOtherContentH: null,
      initOtherContentW: null,
      isInitPaginationCurrentPageFlag: false, // 是否需要初始化分页组件的当前页，一般指切换分类时，将当前页设为1
      directions: [0, 1, 2, 3],
      subPage: null,
      listPageTypeId: null,
      typeIdsArr: [],
      relIdsArr: [],
      isOrBool: false,
      isSsrPage: false,
      activeIndex: 0,
      delay: 0,
      copyHtml: "",
      realBoxBase: 0, // 每个单元格内容实际高度或宽度
      direction: 1, // 0 往下 1 往上
      isCol: false
    }
  },
  props: {
    parentOptions: {
      type: Object
    },
    options: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object,
      default: null
    }
  },
  watch: {
    "options.width"(o, n) {
      const style = window.getComputedStyle(this.$el.parentNode, null)
      this.getParentH = parseInt(style.getPropertyValue("height"), 10) - this.getOtherContentLRHeight()
      this.getParentW = parseInt(style.getPropertyValue("width"), 10)
    },
    "options.height"(o, n) {
      const style = window.getComputedStyle(this.$el.parentNode, null)
      this.getParentH = parseInt(style.getPropertyValue("height"), 10) - this.getOtherContentLRHeight()
      this.getParentW = parseInt(style.getPropertyValue("width"), 10)
    },
    "options.activeIndex"(n, o) {
      if (this.options.noCacheComponent) {
        this.isInitPaginationCurrentPageFlag = true
        this.activeIndex = n
        this.getUpdateData("activeIndex")
      }
    },
    "options.openHideEmptyCell"(n, o) {
      if (this.options.noCacheComponent) {
        this.isInitPaginationCurrentPageFlag = true
        this.getUpdateData("activeIndex")
      }
    },
    "options.encId": {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.reload()
        }
      }
    },
    ids: {
      deep: true,
      handler: function (n, o) {
        if (n.container_id !== this.myid.container_id || n.rect_id !== this.myid.rect_id) {
          this.clearTitleOptActive()
        }
        if (
          this.options.activeCol !== "" &&
          (n.container_id !== this.myid.container_id || n.rect_id !== this.myid.rect_id || n.uid === null)
        ) {
          //如果当前选中的id与当前的col的id不一致，则清除当前col的选中态，以及col内的组件的选中态
          this.$changeOptionsEV("", "activeCol", false, null, {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            pageId: this.myid.pageId
          }, true)
        }
      }
    },
    "options.turnOnScroll": {
      handler(n, o) {
        if (n) {
          this.asyncUpdateComponent(simpleDeepClone(this.options))
          if (!this.options.noCacheComponent) {
            this.reset()
          }
        } else {
          //停止滚动
          this._stopMove()
          //  恢复旧的数据
          this.asyncUpdateComponent(simpleDeepClone(this.options))
          this.xPos = 0
          this.yPos = 0
          this.setTransform()
          this.realBoxBase = 0
        }
      }
    },
    "options.hoverStopScroll": function () {
      this.reset()
    },
    "options.scrollSpeed": function () {
      if (this.options.turnOnScroll) {
        this.reset()
      }
    },
    "options.waitTime": function () {
      if (this.options.turnOnScroll) {
        this.reset()
      }
    },
  },
  computed: {
    emptyData() {
      return this.options.emptyData
    },
    ids() {
      return this.$store.state.states.activeID
    },
    parentW() {
      return 100
    },
    getHandleStyle() {
      return function (item) {
        if (item.elementOptions.length > 0 && this.judgeIsShow(item.elementOptions)) {
          let style = {}
          switch (item.type) {
            case "top":
              style = {
                top: 0,
                height: "2px",
                width: "100%",
                cursor: "n-resize"
              }
              break
            case "bottom":
              style = {
                bottom: 0,
                height: "2px",
                width: "100%",
                cursor: "s-resize"
              }
              break
            case "left":
              style = {
                left: 0,
                width: "2px",
                height: "100%",
                cursor: "w-resize"
              }
              break
            case "right":
              style = {
                right: 0,
                width: "2px",
                height: "100%",
                cursor: "e-resize"
              }
              break
            default:
          }
          return style
        }
      }
    },
    getContentHeight() {
      let emptyLayoutComponentTitleH = 0
      // 针对自由布局做特殊处理，减去左右的宽度
      this.options.titleOptions.forEach(item => {
        if (item.type === "top" || item.type === "bottom") {
          if (item.isShow) emptyLayoutComponentTitleH += item.height
        }
      })
      return {
        height: `calc(100% - ${emptyLayoutComponentTitleH}px)`
      }
    },
    getOtherContentStyle() {
      return function (item) {
        let lrHeight = 0
        if (item.isShow) {
          if (item.type === "top" || item.type === "bottom") {
            return {
              height: item.height + "px",
              width: "100%"
            }
          } else if (item.type === "left" || item.type === "right") {
            // 需要判断'top'和'bottom'的内容是否显示，如果有的话，需要减去上下高度之和
            let lrHeight = 0
            for (let i = 0; i < this.options.titleOptions.length; i++) {
              const titleOptionItem = this.options.titleOptions[i]
              if (titleOptionItem.elementOptions.length === 0) continue
              if (titleOptionItem.type === "top" || titleOptionItem.type === "bottom") {
                for (let j = 0; j < titleOptionItem.elementOptions.length; j++) {
                  if (titleOptionItem.elementOptions[j].isShow) {
                    lrHeight += this.options.titleOptionsHeight
                    break
                  }
                }
              }
            }
            return {
              width: this.options.titleOptionsWidth + "px",
              height: `calc(100% - ${lrHeight}px)`
            }
          } else {
            return
          }
        }
      }
    },
    containerRowStyle() {
      let emptyLayoutComponentTitleW,
        emptyLayoutComponentTitleH = 0
      // 针对自由布局做特殊处理，减去左右的宽度
      this.options.titleOptions.forEach(item => {
        if (item.type === "top" || item.type === "bottom") {
          if (item.isShow) emptyLayoutComponentTitleH += item.height
        }
        if (item.type === "left" || item.type === "right") {
          if (item.isShow) emptyLayoutComponentTitleW += item.width
        }
      })
      return {
        height: this.options.height - emptyLayoutComponentTitleH + "px",
        width: this.options.width - emptyLayoutComponentTitleW + "px"
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let background
      if (!this.options.background || !Array.isArray(this.options.background)) {
        background = [
          {
            type: "img",
            imgUrl: this.options.imgSrc,
            clipSize: this.options.clipSize,
            repeatType: this.options.repeatType,
            alignType: this.options.alignType
          }
        ]
      } else {
        background = this.options.background
      }
      background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          default:
        }
      })
      return containerBg
    },
    containerStyle() {
      let borderW = "",
        padding
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      if (this.options.topNavPaddingTypeFlag == 1) {
        padding = this.options.padding + "px"
      } else {
        padding = `${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return {
        ...this.bgStyle,
        padding: padding,
        "border-style": this.options.borderStyle || "solid",
        // "border-color": this.options.borderIsThemeColor
        //   ? this.$store.state[this.request_prefix].page.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": borderW,
        "box-shadow": [
          this.$parseColor(this.options.boxShadowColor),
          this.options.boxShadowH + "px",
          this.options.boxShadowV + "px",
          this.options.boxShadowBlur + "px",
          this.options.boxShadowSpread + "px"
        ].join(" "),
        "border-top-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopLeftRadius + "px",
        "border-top-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomRightRadius + "px",
        opacity: this.options.opacity / 100
      }
    },
    styleObject() {
      return {
        "border-top-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopLeftRadius + "px",
        "border-top-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomRightRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor),
        "border-width": this.options.borderWidth + "px",
        "box-shadow": [
          this.$parseColor(this.options.boxShadowColor),
          this.options.boxShadowH + "px",
          this.options.boxShadowV + "px",
          this.options.boxShadowBlur + "px",
          this.options.boxShadowSpread + "px"
        ].join(" "),
        transform: "rotate(" + this.options.rotate + "deg)",
        "background-image": "url(" + this.options.imgSrc + ")",
        "background-repeat": this.options.repeatType,
        "background-size": this.options.clipSize,
        "background-position": this.options.alignType,
        opacity: this.options.opacity / 100,
        "--scale-hover": this.options.hoverZoomLevel
      }
    },
    isDrawerModeL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isDrawerModeL", "isDrawerModeL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isDrawerModeL", false, null, this.myid)
      }
    },
    drawerL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerL", "drawerL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerL", false, null, this.myid)
      }
    },
    inBodyL: {
      get() {
        this.isMounted && setImmediate(() => this.reloadDrawer())
        return this.checkAndSetPrimaryVal(this.options, "inBodyL", "inBodyL", true)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyL", false, null, this.myid)
      }
    },
    inBodyR: {
      get() {
        this.isMounted && setImmediate(() => this.reloadDrawer())
        return this.checkAndSetPrimaryVal(this.options, "inBodyR", "inBodyR", true)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyR", false, null, this.myid)
      }
    },
    isDrawerModeR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isDrawerModeR", "isDrawerModeR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isDrawerModeR", false, null, this.myid)
      }
    },
    drawerR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerR", "drawerR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerR", false, null, this.myid)
      }
    },
    getScrollStyle() {
      if (this.options.showScorll === true) {
        return {
          "overflow-y": this.options.scorllType === "vertical" ? "auto" : "hidden",
          "overflow-x": this.options.scorllType === "vertical" ? "hidden" : "auto"
        }
      }
    },
    getScrollStyle1() {
      let base = 200
      if (this.options.noCacheComponent) {
        base = 200 * this.options.scrollMultiple
      }
      const style = {
        transition: `all ${this.ease} ${this.delay}ms`,
        flexDirection: this.layoutType === "col" ? "column" : "row"
      }
      this.layoutType === "col" ? (style.height = base + "%") : (style.width = base + "%")
      return style
    },
    getWidth() {
      return {
        width:
          this.options.showScorll === true && this.options.scorllType !== "vertical"
            ? this.options.contentWidth + "%"
            : "100%",
        height:
          this.options.showScorll === true && this.options.scorllType === "vertical"
            ? this.options.contentWidth + "%"
            : this.options.showScorll === true && this.options.scorllType !== "vertical"
            ? "calc(100% - 1px)"
            : "100%"
      }
    },
    realSingleStopHeight() {
      const [layoutType, options] = this.layoutTypeAndOptions
      const base = layoutType === "col" ? options.rows[0].height : options.cols[0].width
      const real = layoutType === "col" ? this.$refs.realBox.offsetHeight : this.$refs.realBox.offsetWidth
      return (real / 2) * (Number(base.substring(0, base.length - 1)) / 100)
    },
    hoverStopSwitch() {
      return (this.options.hoverStopScroll && this.options.turnOnScroll && !this.emptyData) || false
    },
    // 是否含有tabsTiedPlugin插件
    hasTabsTiledPlugin() {
      return this.options?.pluginName?.some(item => item === "tabsTiledPlugin" || item === "tabsTiledHiddenPlugin")
    },
    layoutTypeAndOptions() {
      return findHistoryLayoutType(this.activeOptions)
    },
    layoutType() {
      return this.layoutTypeAndOptions[0]
    },
    activeOptions() {
      const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      return this.options.rows[useActiveIndex]
    }
  },
  methods: {
    async reload() {
      return new Promise((resolve, reject) => {
        this.showLayout = false
        setImmediate(() => {
          this.showLayout = true
          resolve()
        })
      })
    },
    async reloadDrawer() {
      return new Promise((resolve, reject) => {
        this.showDrawer = false
        setImmediate(() => {
          this.showDrawer = true
          resolve()
        })
      })
    },
    resizingEv: _throttle(function (rect, elementInLayoutId, uid, direction) {
      this.changeVGR(rect, "width", elementInLayoutId, uid, direction)
      this.changeVGR(rect, "height", elementInLayoutId, uid, direction)
    }, 100),
    clearTitleOptActive() {
      let delAllTitleActive = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id
      }
      //初次进来 先取消当前cols中的所有元素的active效果
      this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
    },
    titleClick(direction) {
      if (this.isBigScreenPreview()) return
      const activeID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        pageId: this.myid.pageId,
        directionIndexOther: direction
      }
      this.$store.commit("states/changeActiveID", activeID)
      this.$store.commit("states/changeElementType", this.options.innerElement)
      this.clearTitleOptActive()
      // this.$store.dispatch(this.request_prefix + "/changeLayoutTitleActive", { ...this.ids })
    },
    draggingEv(rect) {},
    activated(elementInLayoutId, uid) {},
    dragstopEv(rect, elementInLayoutId, uid, direction) {
      this.changeVGR(rect, "left", elementInLayoutId, uid, direction)
      this.changeVGR(rect, "top", elementInLayoutId, uid, direction)
    },
    resizestopEv(rect, elementInLayoutId, uid, direction) {
      this.changeVGR(rect, "width", elementInLayoutId, uid, direction)
      this.changeVGR(rect, "height", elementInLayoutId, uid, direction)
    },
    //封装的修改布局组件中的组件的大小和位置的函数
    changeVGR(rect, change, elementInLayoutId, uid, direction) {
      let param1 = {
        ...this.myid,
        option_name: change,
        elementInLayoutId: elementInLayoutId,
        uid: uid,
        directionIndex: direction,
        option_val: rect[change]
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param1)
    },
    activeEv(elementInLayoutId, uid, elementName, direction) {
      let activeLayoutTitle = {
        ...this.myid,
        directionIndex: direction,
        elementInLayoutId: elementInLayoutId
      }
      // this.clicked(null, elementInLayoutId, uid)
      if (!this.$store.state.states.alignHelperStatus) {
        let activeID = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          pageId: this.myid.pageId,
          directionIndex: direction,
          elementInLayoutId: elementInLayoutId
        }
        this.$store.commit("states/changeActiveID", activeID)
        this.$store.dispatch(this.request_prefix + "/setActive", JSON.parse(JSON.stringify(this.myid)))
        this.$store.dispatch(this.request_prefix + "/changeLayoutTitleActive", activeLayoutTitle)
        this.$store.commit("states/changeElementType", elementName)
      } else {
        this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        })
      }
    },
    deactive(elementInLayoutId, uid, elementName, direction) {
      let disableActiveLayoutTitle = {
        ...this.myid,
        directionIndex: direction == "top" ? 0 : direction == "bottom" ? 1 : direction == "left" ? 2 : 3,
        elementInLayoutId: elementInLayoutId
      }
      this.$store.dispatch(this.request_prefix + "/layoutTitleDisableActive", disableActiveLayoutTitle)
    },
    delElementEv(args, elementInLayoutId, uid) {
      let param = {
        ...this.myid,
        elementInLayoutId,
        uid
      }
      this.$store.commit("states/changeElementType", null)
      this.$store.dispatch(this.request_prefix + "/delLayoutElement", param)
    },
    // 辅助线回调事件
    getRefLineParams(params, index) {
      const { vLine, hLine } = params
      let id = 0
      this.lineList[index].vLine = vLine.map(item => {
        item["id"] = ++id
        return item
      })
      this.lineList[index].hLine = hLine.map(item => {
        item["id"] = ++id
        return item
      })
    },
    judgeIsShow(data) {
      let tf = false
      data.forEach((item, index) => {
        if (item.isShow) {
          tf = true
        }
      })
      return tf
    },
    changeHeightMouseDownEv(ev) {
      this.initOtherContentH = ev.screenY
      this.initOtherContentW = ev.screenX
    },
    // 改变tab 最外层那个容器的尺寸
    changeHeightMouseUpEv(ev) {
      let titleOptionDir
      for (let i = 0; i < this.options.titleOptions.length; i++) {
        let elementOptions = this.options.titleOptions[i].elementOptions
        if (elementOptions.length > 0 && this.judgeIsShow(elementOptions)) {
          titleOptionDir = this.options.titleOptions[i].type
          break
        }
      }
      if (titleOptionDir === "top" || titleOptionDir === "bottom") {
        const endY = ev.screenY
        const newH = endY - this.initOtherContentH
        this.initOtherContentH = endY
        const param = {
          ...this.ids,
          option_name: "titleOptionsHeight",
          option_val: this.options.titleOptionsHeight - newH
        }
        this.$store.dispatch(this.request_prefix + "/changeOptions", param)
      } else if (titleOptionDir === "left" || titleOptionDir === "right") {
        const endX = ev.screenX
        const newW = endX - this.initOtherContentW
        this.initOtherContentW = endX
        const param = {
          ...this.ids,
          option_name: "titleOptionsWidth",
          option_val: this.options.titleOptionsWidth - newW
        }
        this.$store.dispatch(this.request_prefix + "/changeOptions", param)
      }
    },
    getUpdateData(initType) {
      // 首次添加自由布局，没有分类信息，需要先获取分类，走全流程查询
      if (!this.restDataUrl) {
        this.asyncUpdateComponent(simpleDeepClone(this.options))
      } else {
        this.timerUpdate(initType)
      }
    },
    async timerUpdate(initType) {
      initType = initType ? initType : "all"
      const updateLayoutData = new UpdateLayoutData(this)
      const menus =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
          : this.$store.state.menu.menu.children[1].children
      const rectAttr = this.options
      const { completeData, drawLayoutAlready, colsIdFromActiveRect, totalRecords, pageSize } =
        await updateLayoutData.upDateRect({
          activeIndex: this.activeIndex,
          pageNum: initType !== "all" ? this.currentPageNum : "", // 第一次初始化的时候不需要传
          typeId:
            this.listPageTypeId && initType !== "activeIndex"
              ? this.listPageTypeId
              : initType !== "all"
              ? this.currentNavMenuValue
              : "",
          typeIds: this.typeIdsArr,
          relIds: this.relIdsArr,
          isOr: this.isOrBool,
          rectAttr: { options: rectAttr },
          cacheDataTypes: this.cacheDataTypes,
          restDataUrl: this.restDataUrl,
          wholeDataTypes: this.wholeDataTypes,
          ids: {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            pageId: this.myid.pageId
          },
          dataCenterContent: this.dataCenterContent,
          addCb: param => {
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          },
          hideComponentCb: param => {
            param.option_name = "opacity"
            param.option_val = 0
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          showComponentCb: param => {
            param.option_name = "opacity"
            param.option_val = 100
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          updateCb: completeparam => {
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            let completeParamClone = Object.assign({}, completeparam)
            completeParamClone.option_name = "opacity"
            completeParamClone.option_val = 100
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
          },
          delElementCb: ids => {
            // this.$store.dispatch(this.request_prefix + "/delLayoutElement", ids)
            let completeparam = Object.assign({}, ids)
            completeparam.option_name = "opacity"
            completeparam.option_val = 0
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
          },
          componentBoxUpdateCb: ({ url, dataId, uid, pageType }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              pageId: this.myid.pageId,
              uid: uid,
              option_val: url,
              option_name: "componentBoxOptions-dataUrl"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
            const dataIdParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              pageId: this.myid.pageId,
              uid: uid,
              option_val: dataId,
              option_name: "componentBoxOptions-dataId"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", dataIdParam)
            const pageTypeParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              pageId: this.myid.pageId,
              uid: uid,
              option_val: pageType,
              option_name: "componentBoxOptions-pageType"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", pageTypeParam)
          },
          componentBoxUpdateOpacity: ({ opacity, uid }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              pageId: this.myid.pageId,
              uid: uid,
              option_val: opacity,
              option_name: "componentBoxOptions-opacity"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
          },
          updateEleCb: (val, content_name, deep, deepName, ids) => {
            this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
          }
        })
      // 只有页面初始化的时候执行一次
      if (initType === "all") {
        this.initTitleOptionsAllComponents(rectAttr, this.restUrl, totalRecords, pageSize)
      }
      if (initType === "pagination" || initType === "navMenu" || initType === "activeIndex") {
        // 找到当前自由布局组件中分页组件的位置
        const result = findTabs(
          rectAttr,
          {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id
          },
          "pagination"
        )
        if (result) {
          const { directionIndex, elementInLayoutId } = result
          this.initPaginationData(directionIndex, elementInLayoutId, totalRecords, pageSize)
        }
      }
      if (this.currentNavMenuValue) {
        const breadCrumbsData = await this.getBreadCrumbsData(this.currentNavMenuValue)
        if (breadCrumbsData) {
          // 如果当前返回了breadCrumbsData的值，则需要初始化面包屑组件
          // 找到当前自由布局组件中面包屑组件的位置
          const result = findTabs(
            rectAttr,
            {
              container_id: this.myid.container_id,
              rect_id: this.myid.rect_id
            },
            "breadCrumbs"
          )
          if (result) {
            const { directionIndex, elementInLayoutId } = result
            this.initBreadCrumbsData(directionIndex, elementInLayoutId, this.restUrl, breadCrumbsData)
          }
        }
      }
      updateLayoutData.startUpdateLayout(completeData, drawLayoutAlready, menus)
      if (this.options.turnOnScroll) {
        setTimeout(() => {
          if (
            this.options.noCacheComponent &&
            this.isBigScreenPreview() &&
            completeData &&
            this.options.oldRowsLength > completeData.length
          ) {
            this.$changeOptionsEV(false, "turnOnScroll", false, null, this.myid, true)
          }
          this.reset()
        }, 500)
      }
    },
    async asyncUpdateComponent(options) {
      if (options.noCacheComponent) {
        const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
        const { engineInstanceId, cacheDataTypes, restDataUrl, restUrl, generalDataTypes, dataCenterContent } = await getAppointCacheData.call(
          this,
          pageId,
          wfwfid,
          websiteId,
          options.appId
        )
        this.cacheDataTypes = cacheDataTypes
        this.wholeDataTypes = generalDataTypes
        this.restDataUrl = restDataUrl
        this.restUrl = restUrl
        this.dataCenterContent = dataCenterContent

        this.$changeOptionsEV(engineInstanceId, "engineInstanceId", false, null, {
          rect_id: this.myid.rect_id,
          container_id: this.myid.container_id,
          pageId: this.myid.pageId
        }, true)
        await this.timerUpdate("all")
        if (this.isBigScreenPreview() && options.autoUpdate !== false) {
          this.reloadTimer = setInterval(this.timerUpdate, parseInt(options.updateTimer) * 1000)
        }
      }
    },
    getOtherContentLRHeight() {
      // 需要判断'top'和'bottom'的内容是否显示，如果有的话，需要减去上下高度之和
      let lrHeight = 0
      for (let i = 0; i < this.options.titleOptions.length; i++) {
        const titleOptionItem = this.options.titleOptions[i]
        if (titleOptionItem.elementOptions.length === 0) continue
        if (titleOptionItem.type === "top" || titleOptionItem.type === "bottom") {
          for (let j = 0; j < titleOptionItem.elementOptions.length; j++) {
            if (titleOptionItem.elementOptions[j].isShow) {
              lrHeight += this.options.titleOptionsHeight
              break
            }
          }
        }
      }
      return lrHeight
    },
    handleColsDragover(e, id) {
      let attribute = e.dataTransfer.getData("rectAttribute")
      if (attribute) {
        attribute = JSON.parse(attribute)
        attribute.options.filedMapping = {
          value: null,
          label: null,
          flag: false,
          checked: true
        }
        const preventComponentMap = [
          "cxautolayout", //自动布局组件
          "layoutcomponent", //布局组件
          "swiper" //轮播组件
        ]
        if (preventComponentMap.find(it => attribute.shape.toLowerCase().includes(it))) return
        e.cancelBubble = true
        this.$store.dispatch("menu/unsetActive", { id: "all" })
        // 针对自动布局模式下的组件 添加标识属性
        attribute.zIndex = 0
        //获取当前鼠标的left和top
        const { width, height } = attribute.options
        let [left, top] = [e.offsetX, e.offsetY]
        ;[attribute.options.left, attribute.options.top] = [left - width / 2, top - height / 2]
        let param = {
          ...this.myid,
          direction: id,
          elementOptions: attribute.options
        }
        this.$store.dispatch(this.request_prefix + "/addComponentInLayoutAround", param)
      }
    },
    changeUid(content) {
      deepChangeUid(content)
    },
    reset() {
      this.isHover = false
      this._cancle()
      setTimeout(() => {
        this._initMove()
      }, 300)
    },
    _cancle() {
      cancelAnimationFrame(this.reqFrame || "")
    },
    enter() {
      if (this.hoverStopSwitch) this._stopMove()
    },
    leave() {
      if (this.hoverStopSwitch) this._startMove()
    },
    _move() {
      // 鼠标移入时拦截_move()
      if (this.isHover) return
      this._cancle() //进入move立即先清除动画 防止频繁touchMove导致多动画同时进行
      let target = this.layoutType === "col" ? "yPos" : "xPos"
      this.reqFrame = requestAnimationFrame(
        function () {
          const h = this.realBoxBase / 2
          let waitTime = this.options.waitTimeUnit ? this.options.waitTime : (this.options.waitTime || 0) * 1000
          if (this.direction === 1) {
            // 上
            if (Math.abs(this[target]) >= h) {
              this[target] = 0
            }
            this[target] -= this.step
          } else if (this.direction === 0) {
            // 下
            if (this[target] >= 0) {
              this[target] = h * -1
            }
            this[target] += this.step
          }
          this.setTransform()
          if (this.singleWaitTime) {
            clearTimeout(this.singleWaitTime)
          }
          if (this.realSingleStopHeight) {
            //是否启动了单行暂停配置
            if (Math.abs(this[target]) % this.realSingleStopHeight < this.step) {
              // 符合条件暂停waitTime
              this.singleWaitTime = setTimeout(() => {
                this._move()
              }, waitTime)
            } else {
              this._move()
            }
          } else {
            this._move()
          }
        }.bind(this)
      )
    },
    _initMove() {
      this.$nextTick(() => {
        this.copyHtml = "" //清空copy
        // 还原位置
        this.xPos = 0
        this.yPos = 0
        this.step = 1
        if (this.options.turnOnScroll) {
          this.ease = "linear"
          this.delay = 0
        } else {
          this.ease = "linear"
          this.delay = 400
          return
        }
        // 是否可以滚动判断
        if (!this.emptyData && !this.preventScroll) {
          let timer
          if (timer) clearTimeout(timer)
          this.copyHtml = this.$refs.slotList.innerHTML
          setTimeout(() => {
            const realBox = this.$refs.realBox
            this.realBoxBase =
              this.layoutType === "col" ? realBox.offsetHeight : realBox.offsetWidth
            const containerH = this.layoutType === "col" ? realBox.parentElement.offsetHeight : realBox.parentElement.offsetWidth
            // 以16.7ms一帧计算，滚动一屏需要的时间
            const count = (this.options.scrollSpeed || 6000) / 16.7
            this.step = Math.ceil(containerH / count)
            this._move()
          }, 100)
        } else {
          this._cancle()
          this.xPos = 0
          this.yPos = 0
          this.step = 1
        }
      })
    },
    _startMove() {
      this.isHover = false //开启_move
      this._move()
    },
    _stopMove() {
      this.isHover = true //关闭_move
      // 防止频频hover进出单步滚动,导致定时器乱掉
      if (this.singleWaitTime) clearTimeout(this.singleWaitTime)
      this._cancle()
    },
    async updateData() {
      this.getUpdateData("all")
    },
    setTransform() {
      if(this.$refs.realBox) {
        this.$refs.realBox.style.transform = `translate(${this.xPos}px, ${this.yPos}px)`
      }
    },
    /* 后台监听更新大屏数据 */
    updateDataFun({ data }) {
      if (data.type === "pageInIframeUpdateData" && this.options?.appId) {
        this.timerUpdate("all")
      }
    },
  },
  async mounted() {
    window.addEventListener("message", this.updateDataFun)
    this.isMounted = true
    this.activeTabId = this.options.tabs ? this.options.tabs.filter(tab => tab.isActive)[0].id : ""
    const style = window.getComputedStyle(this.$el.parentNode, null)
    this.getParentH = parseInt(style.getPropertyValue("height"), 10) - this.getOtherContentLRHeight()
    this.getParentW = parseInt(style.getPropertyValue("width"), 10)
    await this.asyncUpdateComponent(simpleDeepClone(this.options))
    this.$initPlugin(this.options?.pluginName)
    this.$eventBus.$on(`update-layout-data-eventBus-${this.myid.container_id}-${this.myid.rect_id}`, msg => {
      console.log("msg", msg)
      if (msg) {
        if (msg.hasOwnProperty("typeId")) this.listPageTypeId = msg.typeId
        //多级筛选的参数
        if (msg.hasOwnProperty("typeIds")) this.typeIdsArr = msg.typeIds
        if (msg.hasOwnProperty("relIds")) this.relIdsArr = msg.relIds
        if (msg.hasOwnProperty("isOr")) this.isOrBool = msg.isOr
        if (this.typeIdsArr?.length) {
          this.listPageTypeId = ""
        }
        if (msg.hasOwnProperty("layoutSrollUpdateFlag")) {
          this.reset()
        } else {
          this.timerUpdate("all")
        }
      }
    })
    //执行滚动
    setTimeout(() => {
      this._initMove()
    }, 1000)
  },
  beforeCreate() {
    this.reqFrame = null // move动画的animationFrame定时器
    this.singleWaitTime = null // single 单步滚动的定时器
    this.isHover = false // mouseenter mouseleave 控制this._move()的开关
    this.ease = "ease-in"
  },
  beforeDestroy() {
    this.$eventBus.$off(`update-layout-data-eventBus-${this.myid.container_id}-${this.myid.rect_id}`)
    clearInterval(this.reloadTimer)
    this.reloadTimer = null

    this._cancle()
    clearTimeout(this.singleWaitTime)
    window.removeEventListener("message", this.updateDataFun)
  }
}
</script>

<style scoped>
.custom-handle {
  display: none;
  width: 100%;
  height: 2px;
  position: absolute;
  top: 0;
  left: 0;
  background: var(--themeColor);
  cursor: move;
}
.bv-example-row {
  padding: 0;
}
.headerBox {
  width: 100%;
  height: 50px;
  position: relative;
}
.other_content {
  position: relative;
  overflow-x: clip;
}
.other_content:hover {
  box-shadow: 0 0 0 1px var(--themeColor) inset;
}
.other_content:hover .custom-handle {
  display: block;
}
::v-deep .el-drawer__body .other_content {
  display: block !important;
}
.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}
.content_otherLR {
  display: flex;
  position: relative;
}
.zIndex0 {
  z-index: 0;
}
::v-deep .el-drawer__wrapper {
  position: absolute;
}
::v-deep .v-modal {
  position: absolute;
}
.content_center {
  flex: 1;
  height: 100%;
}
.content_center1 {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.realBox {
  width: 100%;
  height: 200%;
  display: flex;
  overflow: hidden;
}
.content_center_div {
  overflow: hidden;
  width: 100%;
  height: 50%;
}
.content_center_div1 {
  overflow: hidden;
  width: 100%;
  height: 50%;
}
.content_center::-webkit-scrollbar {
  display: block;
}
</style>
